import React, {useState, useEffect} from 'react';
import FileSaver from 'file-saver';
import {ContentHeader} from '@components';
import {Button, Form} from 'react-bootstrap';
import Select from 'react-select';
import {Grid, _} from 'gridjs-react';
import Switch from 'react-bootstrap-switch';
import {read, utils, write} from 'xlsx';
import {toast} from 'react-toastify';
import {PfButton} from '@profabric/react-components';
import * as AuthService from '../services/auth';
import {logoutUser} from '@store/reducers/auth';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import ClockLoader from 'react-spinners/ClockLoader';
import TableUser from './report/TableUser';
export default function Users() {
  useEffect(() => {
    downloadDropdownWs();
  }, []);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [isDataLoading, setDataLoading] = useState(false);
  const [item, setItem] = useState<any>({});
  const [data, setData] = useState<any[]>([]);
  const [blacklist, setBlacklist] = useState<any[]>([]);
  const [blacklistXlsx, setBlacklistXlsx] = useState<any[]>([]);
  const [keyword, setKeyword] = useState('');
  const [page, setPage] = useState(0);
  const [dropdownCountry, setDropdownCountry] = useState<any[]>([]);
  const [state, setState] = useState({
    countryid: {value: '', label: ''}
  });

  interface Company {
    BLACK_LIST: string;
  }

  const downloadBlacklistXlsx = () => {
    try {
      console.log(blacklist);
      const ws = utils.json_to_sheet(blacklist);
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, 'Sheet1');
      const wbout = write(wb, {
        bookType: 'xlsx',
        bookSST: false,
        type: 'array'
      });
      FileSaver.saveAs(
        new Blob([wbout], {type: 'application/octet-stream'}),
        `${state.countryid.value}-${new Date().toISOString()}.xlsx`
      );
    } catch (err) {
      console.error('export error', err);
    }
  };

  const uploadBlacklistXlsx = async () => {
    try {
      if (blacklistXlsx.length === 0) {
        toast.warn('Blacklist is zero amount!');
      } else {
        setLoading(true);
        const params = await AuthService.uploadBlacklist(
          state.countryid.value,
          blacklistXlsx
        );
        if (params.error) throw 'timeout';
        toast.success('Upload is succeed!');
        setBlacklistXlsx([]);
        setLoading(false);
      }
    } catch (error: any) {
      dispatch(logoutUser());
      navigate('/login');
    }
  };

  const updateData = (
    prevState: any[],
    id: any,
    state: boolean | null
  ): any[] => {
    const newData = prevState.reduce((prev, curr) => {
      if (curr.id === id) {
        prev.push({...curr, IS_ACTIVE: state});
      } else {
        prev.push(curr);
      }
      return prev;
    }, []);
    return newData;
  };

  const updateUserWs = async (input: any) => {
    try {
      console.log(input);
      let params: any;
      params = await AuthService.updateUser(input);
      if (params.error) throw 'timeout';
      toast.success('Update customer is succeed!');

      //ไม่โหลดซ้ำแล้ว
      downloadReportWsInit(input.COUNTRY_CODE);
      // const result = data.map((item) => {
      //     if (item.id === input.id) {
      //         return input;
      //     }
      //     return item;
      // });
      // setData(result);
      
      return true;
    } catch (error: any) {
      toast.error('Update customer is Failed!');
      return false;
    }
  };

  const downloadBlacklistWs = async (country_code: any) => {
    try {
      const params = await AuthService.downloadBlacklist(country_code);
      if (params.error) throw 'timeout';
      setBlacklist(params);
    } catch (error: any) {
      dispatch(logoutUser());
      navigate('/login');
    }
  };

  const setPageHandle = (page : number) => {
    setPage(page);
  }

  const downloadReportWsInit = async (country_code: any) => {
    try {
      setDataLoading(true);
      const params = await AuthService.downloadReport(
        '2',
        '2000-01-01',
        new Date().toISOString().split('T')[0],
        country_code
      );
      if (params.error) throw 'timeout';
      // setData(
      //   params.map((e: any) => [
      //     _(
      //       <Switch
      //         bsSize={'mini'}
      //         onChange={async (el, state) => {
      //           const result = await updateUserWs({
      //             id: e.id,
      //             IS_ACTIVE: state,
      //             COUNTRY_CODE: e.COUNTRY_CODE
      //           });
      //           if (result)
      //             setData((prevState) => updateData(prevState, e.id, state));
      //         }}
      //         value={e.IS_ACTIVE}
      //       />
      //     ),
      //     e.ROW_NO,
      //     e.USERNAME,
      //     e.NAME,
      //     e.TEL,
      //     _(
      //       <a
      //         className="text-muted"
      //         onClick={() => {
      //           handleview(e);
      //         }}
      //       >
      //         <i className="fas fa-search" />
      //       </a>
      //     )
      //   ])
      // );
      console.log(params);
      setData(params);
      setDataLoading(false);
      // setKeyword(' ');
      // setPage(0);
    } catch (error: any) {
      dispatch(logoutUser());
      navigate('/login');
    }
  };

  const downloadDropdownWs = async () => {
    try {
      const dropdowns = await AuthService.downloadDropdown();

      const countryDropdown = dropdowns.reduce(function (acc: any, curr: any) {
        if (curr.TYPE === 'COUNTRY') {
          delete curr.TYPE;
          return [...acc, curr];
        }
        return [...acc];
      }, []);

      setDropdownCountry(countryDropdown);
    } catch (error: any) {}
  };

  const validateFile = async (file: File) => {
    try {
      const data = await file.arrayBuffer();
      const workbook = read(data);
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      let jsonData = utils.sheet_to_json<Company>(worksheet);
      console.log(jsonData);
      jsonData = jsonData.map((e, i) => ({
        ...e,
        index: i + 1
      }));
      if (!jsonData[0].hasOwnProperty('BLACK_LIST')) {
        throw 'error';
      }
      return jsonData;
    } catch {
      return [];
    }
  };

  const fileUpload = async (e: any) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      const res1 = await validateFile(file);
      if (res1.length > 0) {
        setBlacklistXlsx(res1);
      } else {
        toast.error('Wrong file format!');
      }
    }
  };
  return (
    <div>
      <ContentHeader title="Customers and Blacklist" />
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-md-9">
              <div className="card card-primary">
                <div className={isDataLoading ? 'overlay dark' : 'd-none'}>
                  <ClockLoader color="#c4c4c4" />
                  {/* <i className="fas fa-3x fa-sync-alt"></i> */}
                </div>
                <div className="card-header">
                  <h3 className="card-title">Customers</h3>
                </div>
                <div className="card-body">
                  <Select
                    className="mb-3"
                    menuPortalTarget={document.body} 
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    placeholder={'Select Country'}
                    options={dropdownCountry}
                    id="countryid"
                    onChange={(v: any) => {
                      setState((prevState) => ({...prevState, countryid: v}));
                      downloadReportWsInit(v.value);
                      downloadBlacklistWs(v.value);
                    }}
                  />
                  {/* <Grid
                    style={{
                      table: {
                        'font-size': '12px'
                      }
                    }}
                    data={data}
                    columns={[
                      '#',
                      {
                        name: 'Id',
                        width: '80px'
                      },
                      'Username',
                      'Name',
                      'Phone',
                      'View'
                    ]}
                    search={true}
                    // search={{keyword: keyword}}
                    pagination={{
                      limit: 10,
                      page: page
                    }}
                    resetPageOnUpdate={false}
                  /> */}
                  <TableUser names={data} onUpdate={updateUserWs} onPageChange={setPageHandle} page={page}/>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3">
              <div className="card card-danger">
                <div className={isLoading ? 'overlay dark' : 'd-none'}>
                  <ClockLoader color="#c4c4c4" />
                  {/* <i className="fas fa-3x fa-sync-alt"></i> */}
                </div>
                <div className="card-header">
                  <h3 className="card-title">Blacklist Companies</h3>
                  <div className="card-tools">
                    <button
                      onClick={downloadBlacklistXlsx}
                      type="button"
                      className="btn btn-tool"
                    >
                      <i className="fa fa-file-csv" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <Form.Control
                    type="file"
                    accept=".xlsx, .xls"
                    onChange={fileUpload}
                  />
                </div>
                <div className="card-footer">
                  <PfButton
                    disabled={state.countryid.value === ''}
                    className="col-md-12"
                    loading={false}
                    theme={'primary'}
                    block
                    onClick={uploadBlacklistXlsx}
                    type="button"
                  >
                    Upload {blacklistXlsx.length} items
                  </PfButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
